module.exports = __webpack_public_path__ + "img/envelove.61d3d5ca.svg";